/**
 * TestAccountCleanupCard (Jul-2026, User-Wunsch) — von der Händler-Verifizierung
 * in die Systempflege verschoben: Test-Konten (@example.com) inkl. Daten löschen.
 */
import { useEffect, useState } from "react";
import { Loader2, Trash2, UserX } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";

export const TestAccountCleanupCard = () => {
    const [info, setInfo] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = async () => {
        try { const { data } = await api.get("/admin/test-account-cleanup"); setInfo(data); }
        catch { setInfo(null); }
    };
    useEffect(() => { load(); }, []);

    const run = async () => {
        if (!window.confirm(`${info?.total || 0} Test-Konten (@example.com) inkl. zugehöriger Daten (Inserate, Kunden, Aufträge …) endgültig löschen?`)) return;
        setBusy(true);
        try {
            const { data } = await api.post("/admin/test-account-cleanup");
            toast.success(`${data.deleted_users} Test-Konten gelöscht`);
            load();
        } catch (e) { toast.error(e.response?.data?.detail || "Bereinigung fehlgeschlagen"); }
        finally { setBusy(false); }
    };

    return (
        <div className="bg-white border-2 border-amber-300 rounded-sm p-4" data-testid="test-account-cleanup-card">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <h2 className="font-display font-black text-lg flex items-center gap-2">
                        <UserX className="w-5 h-5 text-amber-600" /> Test-Konten löschen
                    </h2>
                    <p className="text-xs text-gray-500 mt-0.5" data-testid="test-account-cleanup-info">
                        {info && (info.total > 0 || info.test_partners > 0)
                            ? <>{info.total > 0 && <><span className="font-black text-amber-800">{info.total} Test-Konten</span> (@example.com — pytest/e2e/conv-test): {Object.entries(info.by_role || {}).map(([r, n]) => `${n}× ${r}`).join(" · ")}</>}{info.test_partners > 0 && <>{info.total > 0 ? " · " : ""}<span className="font-black text-amber-800">{info.test_partners} Test-Partner</span> (Verzeichnis, „Pytest …")</>}</>
                            : "Keine Test-Konten (@example.com) oder Test-Partner vorhanden."}
                    </p>
                </div>
                {info && (info.total > 0 || info.test_partners > 0) && (
                    <Button type="button" onClick={run} disabled={busy}
                        className="h-9 rounded-sm bg-red-600 hover:bg-red-700 text-white font-bold text-xs uppercase tracking-wider"
                        data-testid="test-account-cleanup-btn">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Trash2 className="w-4 h-4 mr-1.5" />}
                        Test-Konten löschen
                    </Button>
                )}
            </div>
        </div>
    );
};
